module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-photographer-62eb54bc62288e7d2862f21f63a4f84c.png";